module.exports = __webpack_public_path__ + "static/p2-488f37ba91d3218609456f940a2c5edc.jpg";